import type { SideNavigationProps } from '@cloudscape-design/components/side-navigation';

/** Side navigation of the gateway VPN console. External links open the backing repos' docs. */
export const NAV_ITEMS: SideNavigationProps.Item[] = [
  {
    type: 'section',
    text: 'VPN',
    items: [{ type: 'link', text: 'Gateway enrollment', href: '/vpn' }],
  },
  { type: 'divider' },
  {
    type: 'section',
    text: 'Documentation',
    items: [
      { type: 'link', text: 'Console guide', href: 'https://github.com/Viaanix/fleet-cert-console#readme', external: true },
      { type: 'link', text: 'VPN control plane & hub', href: 'https://github.com/Viaanix/vpn-iot-gateway-infra#readme', external: true },
      { type: 'link', text: 'Gateway client & installer', href: 'https://github.com/Viaanix/vpn-gateway-client#readme', external: true },
      { type: 'link', text: 'Fleet provisioning proxy', href: 'https://github.com/Viaanix/iot-fleet-provisioning-proxy#readme', external: true },
    ],
  },
];
